<script setup>
import ArrowRight from './icons/ArrowRight.vue'
import { useAppStore } from '~/store/main'

const props = defineProps({
  label: { type: String, default: '' },
  slug: { type: String, default: '' },
  contentType: { type: String, default: '' },
  root: { type: String, default: '' },
  id: { type: String, default: '' },
  name: { type: String, default: '' },
  arrow: { type: Boolean, default: false },
  bread: { type: Boolean, default: false },
  back: { type: Boolean, default: false },
  navigation: { type: Boolean, default: false },
})

const store = useAppStore()
const { setShowMenuLayer, setLayer, setLayerId } = store

const localePath = useLocalePath()
const { locale } = useI18n()

const router = useRouter()

const setLink = computed(() => {
  if (props.name) {
    return { name: props.name }
  } else if (props.slug === '#') {
    const itemSlug = props.label
      .toLowerCase()
      .replace(/ /g, '-')
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '')
    switch (props.root) {
      case 'studium':
        return {
          name: 'studium-id-item',
          params: { id: props.id, item: itemSlug },
        }
      case 'akademie':
        return {
          name: 'akademie-id-item',
          params: { id: props.id, item: itemSlug },
        }
      case 'program':
        return {
          name: 'program-id-item',
          params: { id: props.id, item: itemSlug },
        }
      default:
        return {}
    }
  } else if (props.slug === '#lide') {
    return { name: 'other-people' }
  } else if (props.slug === '#publikace') {
    return { name: 'other-publication' }
  } else if (props.slug === '#search') {
    return { name: 'search' }
  } else {
    switch (props.contentType) {
      case 'category':
        return { name: 'program-category', params: { category: props.slug } }
      case 'article':
        return { name: 'article-slug', params: { slug: props.slug } }
      case 'department':
        return { name: 'department-slug', params: { slug: props.slug } }
      case 'publication':
        return { name: 'publication-slug', params: { slug: props.slug } }
      case 'employee':
        return { name: 'employee-slug', params: { slug: props.slug } }
      case 'student':
        return { name: 'student-slug', params: { slug: props.slug } }
      case 'notice':
        return { name: 'notice-slug', params: { slug: props.slug } }
      default:
        return {}
    }
  }
})

const openNavigation = (event) => {
  event.stopPropagation()
  if (props.slug === '#') {
    setLayer(3)
    setLayerId(props.id)
    setShowMenuLayer(true)
  } else {
    setTimeout(() => {
      if (setLink.value && setLink.value.name) {
        router
          .push({
            name: `${setLink.value.name}___${locale.value}`,
            params: setLink.value.params || {},
          })
          .then(() => {
            setShowMenuLayer(false)
          })
      }
    }, 100)
  }
}
</script>

<template>
  <div class="text_main">
    <a
      v-if="slug && slug.includes('http')"
      target="_blank"
      :href="slug"
      class="link rowLink is_c2"
    >
      <p>{{ label }}</p>
    </a>

    <NuxtLink v-else-if="bread" class="link__inverse" :to="localePath(setLink)">
      <span>{{ label }}</span>
    </NuxtLink>

    <NuxtLink v-else-if="back" :to="localePath(setLink)">
      <div class="arrowbox">
        <i class="arrow left"></i>
      </div>
    </NuxtLink>

    <a
      v-else-if="navigation"
      class="link rowLink link__navigation"
      :class="{
        'link__navigation--studium': root === 'studium',
        'link__navigation--akademie': root === 'akademie',
        'link__navigation--program': root === 'program',
      }"
      href="#"
      @click="openNavigation"
    >
      <p>{{ label }}</p>
      <ArrowRight
        v-if="slug === '#' || arrow || contentType === 'program'"
        width="16"
        height="16"
      />
    </a>

    <NuxtLink
      v-else
      class="link rowLink link__inverse"
      :to="localePath(setLink)"
    >
      <p>{{ label }}</p>
      <ArrowRight
        v-if="slug === '#' || arrow || contentType === 'program'"
        width="16"
        height="16"
      />
    </NuxtLink>
  </div>
</template>
